export default __webpack_public_path__ + "img/df1888c88c3715bd98fd9f1045893ec8.png";